import React from 'react';
import PropTypes from 'prop-types';
import { PauseSlideContentV1 } from '../PauseSlideContentV1';
import { PauseSlideContentV2 } from '../PauseSlideContentV2';
import { PauseSlideContentV3 } from '../PauseSlideContentV3';
import { PauseSlideContentV4 } from '../PauseSlideContentV4';
import { PauseSlideContentV5 } from '../PauseSlideContentV5';
import { PauseSlideContentV6 } from '../PauseSlideContentV6';
import { PauseSlideContentV7 } from '../PauseSlideContentV7';
import { PauseSlideContentV8 } from '../PauseSlideContentV8';
import { PauseSlideContentV9 } from '../PauseSlideContentV9';
import { PauseSlideContentV10 } from '../PauseSlideContentV10';
import { PauseSlideContentV12 } from '../PauseSlideContentV12';
import { PauseSlideContentV13 } from '../PauseSlideContentV13';
import { PauseSlideContentV14 } from '../PauseSlideContentV14';
import { PauseSlideContentV20 } from '../PauseSlideContentV20';
import { PauseSlideContentV21 } from '../PauseSlideContentV21';
import { PauseSlideContentV22 } from '../PauseSlideContentV22';
import { PauseSlideContentV23 } from '../PauseSlideContentV23';
import { PauseSlideContentV24 } from '../PauseSlideContentV24';
import { PauseSlideContentV25 } from '../PauseSlideContentV25';

const PAUSE_SLIDE_VARIANTS = {
    v1: PauseSlideContentV1,
    v2: PauseSlideContentV2,
    v3: PauseSlideContentV3,
    v4: PauseSlideContentV4,
    v5: PauseSlideContentV5,
    v6: PauseSlideContentV6,
    v7: PauseSlideContentV7,
    v8: PauseSlideContentV8,
    v9: PauseSlideContentV9,
    v10: PauseSlideContentV10,
    v12: PauseSlideContentV12,
    v13: PauseSlideContentV13,
    v14: PauseSlideContentV14,
    v20: PauseSlideContentV20,
    v21: PauseSlideContentV21,
    v22: PauseSlideContentV22,
    v23: PauseSlideContentV23,
    v24: PauseSlideContentV24,
    v25: PauseSlideContentV25
};

function PauseSlide({ variant = 'v1', ...contentProps }) {
    const Content = PAUSE_SLIDE_VARIANTS[variant] || PauseSlideContentV1;

    return <Content {...contentProps} />;
}

PauseSlide.propTypes = {
    variant: PropTypes.oneOf(Object.keys(PAUSE_SLIDE_VARIANTS))
};

export {
    PauseSlide
};
